<div fxLayout="column">
    <mat-dialog-actions fxFlex="0 0 auto" align="end">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-button color="primary" (click)="submit()" [mat-dialog-close]="submitResult">Submit</button>
    </mat-dialog-actions>
</div>